
import { ComponentIds } from '~/utils/componentIds';
import ProfileImg from '@/components/ui/atom/ProfileImg.vue';
import { mapGetters } from 'vuex';
import OnlineStatusIndicator from '@/components/ui/atom/OnlineStatusIndicator.vue';
import Searchbar from './Searchbar.vue';
import { isMobileResponsive } from '@/utils/mixins';

export default {
  name: 'NavContent',
  components: {
    ProfileImg,
    OnlineStatusIndicator,
    Searchbar,
  },
  mixins: [isMobileResponsive],
  props: {
    searchPopupShown: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      required: true,
      validator: (v) => ['search', 'title', 'portfolio', 'profile'].includes(v),
    },
    pageTitle: {
      type: String,
      default: '',
      required: false,
    },
    profile: {
      type: [Object, null],
      default: null,
      required: false,
    },
  },
  emits: ['focus', 'blur', 'input', 'popup-shown'],
  data() {
    return {
      showPortfolioDropdownList: false,
      portfoliosInDropdown: [],
    };
  },
  computed: {
    searchbarId() {
      return ComponentIds.SearchbarId;
    },
    ...mapGetters('messaging', ['onlineUsers']),
    isProfileOnline() {
      return (
        this.profile &&
        !!this.onlineUsers._onlineUsers.find(
          (u) => u.userId === this.profile.userId
        )
      );
    },
  },
};
